import { schema } from "normalizr";

export const filter = new schema.Entity("filters");
export const arrayOfFilters = new schema.Array(filter);
